import { defineMessages } from 'react-intl';

export const maintenanceBannerMessages = defineMessages({
  dismiss: {
    id: 'maintenanceBanner.dismiss',
    defaultMessage: 'Dismiss',
  },
});
